"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  question: "Jaké osobní údaje shromažďujeme?",
  answer: "Shromažďujeme pouze nezbytné údaje pro rezervaci vašich služeb, jako je jméno, telefonní číslo a e-mailová adresa. Tyto informace slouží výhradně k potvrzení termínu a zajištění vaší maximální spokojenosti."
}, {
  id: "faq-2",
  question: "Jak zajišťujeme bezpečnost vašich dat?",
  answer: "Vaše soukromí je naší prioritou. Všechna data jsou uložena na zabezpečených serverech s šifrováním a přístup k nim mají pouze oprávnění pracovníci našeho salonu v souladu s přísnými bezpečnostními protokoly."
}, {
  id: "faq-3",
  question: "Soulad s nařízením GDPR",
  answer: "Plně dodržujeme obecné nařízení o ochraně osobních údajů (GDPR). Máte právo kdykoli požádat o výpis svých údajů, jejich opravu nebo trvalé odstranění z naší databáze."
}, {
  id: "faq-4",
  question: "Sdílíme vaše údaje s třetími stranami?",
  answer: "Nikdy neprodáváme ani neposkytujeme vaše osobní údaje třetím stranám pro marketingové účely. Údaje jsou využívány interně pouze pro účely správy vašich návštěv a věrnostního programu."
}, {
  id: "faq-5",
  question: "Jak dlouho vaše údaje uchováváme?",
  answer: "Osobní údaje uchováváme po dobu nezbytně nutnou pro poskytování našich služeb nebo po dobu vyžadovanou zákonem. Poté jsou data bezpečně a nenávratně smazána."
}];
export default function WithdrawalFaqs() {
  return <section data-section-id="243168" id="privacy-notice" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-[800px]">
          <div className="mb-10 text-center md:mb-16">
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
              Ochrana Soukromí
            </h2>
            <p className="mt-4 font-default text-lg text-muted-foreground">
              Transparentní informace o tom, jak pečujeme o vaše osobní údaje a zajišťujeme jejich bezpečí.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="mb-4 overflow-hidden rounded-lg border border-primary/20 bg-card/50 backdrop-blur-sm transition-all duration-300 last:mb-0 last:border-b last:border-b-primary/20 data-[state=open]:bg-accent/30 data-[state=open]:shadow-md">
                <AccordionTrigger className="px-6 py-5 font-default text-base font-semibold text-foreground hover:no-underline md:text-lg [&>svg]:size-5 [&>svg]:stroke-[2] [&>svg]:text-primary [&>svg]:transition-transform [&>svg]:duration-300">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5 pt-0 font-default text-base font-normal leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>

          <div className="mt-12 text-center">
            
          </div>
        </div>
      </div>
    </section>;
}